// Delay (ms) after a transcript change before re-checking the scroll shadow,
// to let smooth-scroll/layout settle past the rAF tick.
export const SHADOW_RECHECK_DELAY_MS = 220;
// Pixel tolerance below which scrollTop / overflow is treated as "at top" /
// "no overflow" (sub-pixel rounding noise).
export const SCROLL_EPSILON_PX = 1;

// True when the element overflows AND is scrolled away from the top — i.e. a
// top shadow should be shown. Pure so it can be unit-tested without a DOM
// layout (JSDOM does not implement scroll metrics).
export const hasScrollShadow = (el: {
  scrollHeight: number;
  clientHeight: number;
  scrollTop: number;
}): boolean =>
  el.scrollHeight - el.clientHeight > SCROLL_EPSILON_PX &&
  el.scrollTop > SCROLL_EPSILON_PX;

// Clamp a percentage into [0, 100].
export const clampPercent = (value: number): number =>
  Math.min(100, Math.max(0, value));
